import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';

import { AppComponentGenericComponent } from '../../custom/app-component-generic/app-component-generic.component';
import { DataService } from '../../../services/data.service';

import { GenericFilterParameter } from '../../../models/generic-comunication-cmp';
import { UserByComune } from '../../../models/user';
import { createMasterAnimation, createDetailAnimation } from '../../../animations/master-detail.animation';

@Component({
  selector: 'app-utenti-permessi',
  templateUrl: './utenti-permessi.component.html',
  styleUrls: ['./utenti-permessi.component.css'],
  animations: [
    createMasterAnimation('masterSlider'),
    createDetailAnimation('detailSlider'),
  ]
})
export class UtentiPermessiComponent extends AppComponentGenericComponent implements OnInit {
    // Detail
    masterState: string;
    detailState: string;
    userByComuneSelected: UserByComune;

    // parametri
    parametriString: string = "{}";
    parametri: GenericFilterParameter = null;

    constructor(protected dataService: DataService){
	super(dataService, 'utenti-permessi');
    }

    ngOnInit(){
	this.resetState();
	this.userByComuneSelected = null;
	this.parametri = new GenericFilterParameter();
	this.parametri.setDettaglioView(Boolean(this.userByComuneSelected));
	this.writePermission = this.checkPermission('gestione-utenti','write','global');
    }

    apriModifica(userByComune: UserByComune){
        this.userByComuneSelected = userByComune;
	console.log('utenti permessi modifica userByComuneSelected', this.userByComuneSelected);
        this.parametri.setDettaglioView(Boolean(this.userByComuneSelected));
        this.updateParametri();
        this.changeState();
    }

    apriNuovo(){
    }

    updateParametri(){
        //console.log('CMP|OPERATORI-PERMESSI - CHANGE UPDATEPARAMETRI', this.parametri);
        this.parametriString = this.parametri.generateParametriToString();
        //console.log('CMP|OPERATORI-PERMESSI - CHANGE UPDATEPARAMETRISTRING', this.parametriString);
    }

    manageEventInner($event){
	console.log("CMP|UTENTI-PERMESSI - manageEventInner", $event);
	if($event.resetState){
	    this.resetState();
	}
    }

    manageEventOperator($event){
	console.log("CMP|UTENTI-PERMESSI - manageEventOperator", $event);
	let type = null;
	if($event.type){
	    type = $event.type;
	    switch(type){
		case 'apriNuovo':
		    console.log("type apriNuovo!");
		    break;
		case 'apriModifica':
		    console.log("type apriModifica event:", $event.data);
		    this.dataService.getUtentiService().getUserByComuneComplete($event.data, this.dataService.getComuniService().getComuneId(), (userByComune) =>{
			console.log("type apriModifica dopo", userByComune);
			this.apriModifica(userByComune);
		    });
		    break;
		default:
		    console.log("type non riconosciuto!");
		    break;
	    }
	}else{
	    console.log("event non formattato!");
	}
    }

    animationDetailStarted($event) {
	//console.log('animation Detail Start', $event);
    }

    animationDetailDone($event) {
	//console.log('animation Detail End', $event);
    }

    animationMasterStarted($event) {
	//console.log('animation Master Start', $event);
    }

    animationMasterDone($event) {
	//console.log('animation Master End', $event);
    }

    changeState(){
	if(this.masterState == "background"){
		this.masterState = "foreground";
	}else{
		this.masterState = "background";
	}

	if(this.detailState == "background"){
		this.detailState = "foreground";
	}else{
		this.detailState = "background";
	}
    }

    resetState(){
	this.masterState = "foreground";
	this.detailState = "background";
    }

    ngOnDestroy() {
    }
}
